import { Link } from "react-router-dom";
import { Mic2 } from "lucide-react";
import ChannelStrip, { TAKE_COLOR } from "@/components/creator/mix/ChannelStrip";
import MixSlider from "@/components/creator/mix/MixSlider";
import { fmtAgo } from "@/lib/studioApi";

const takeName = (t) => `Take ${t.take_number || "?"}${t.source === "uploaded" ? " (file)" : ""}`;

/** Your recorded / uploaded vocal: pick the take, nudge its timing, then mix it like any other part. */
export default function TakeStrip({ takes, settings, audible, onPick, onChange, projectId }) {
  if (!takes.length) {
    return (
      <div data-testid="mix-strip-take-empty" className="flex w-[148px] shrink-0 flex-col items-start gap-3 rounded-2xl border border-dashed border-white/12 bg-white/[0.02] p-3">
        <span className={`h-6 w-1.5 rounded-full bg-gradient-to-b ${TAKE_COLOR}`} />
        <p className="font-display text-[13px] font-semibold">Your Voice</p>
        <p className="text-[11px] leading-snug text-white/50">No vocal take on this version yet. Sing it yourself and it appears here as its own channel.</p>
        {projectId ? (
          <Link to={`/create/project/${projectId}/sing`} data-testid="mix-take-record" className="inline-flex items-center gap-1.5 rounded-full border border-rose-300/40 bg-rose-500/10 px-3 py-1.5 font-mono text-[10px] uppercase tracking-wider text-rose-100 hover:bg-rose-500/20">
            <Mic2 className="h-3 w-3" /> Sing it myself
          </Link>
        ) : null}
      </div>
    );
  }
  const track = settings.tracks.take;
  return (
    <ChannelStrip name="take" label="Your Voice" track={track} audible={audible && Boolean(settings.take_id)} onChange={onChange} color={TAKE_COLOR}>
      <select data-testid="mix-take-select" value={settings.take_id || ""} onChange={(e) => onPick(e.target.value || null)} aria-label="Which take"
        className="w-full rounded-lg border border-white/10 bg-black/50 px-2 py-1.5 text-[11px] text-white focus:border-fuchsia-300/60 focus:outline-none">
        <option value="">Leave my voice out</option>
        {takes.map((t) => <option key={t.id} value={t.id} title={t.singer_name || undefined}>{`${takeName(t)} · ${fmtAgo(t.created_at)}`}</option>)}
      </select>
      <MixSlider id="mix-take-offset" label="Timing" value={track.offset_ms} min={-500} max={500} step={10} disabled={!settings.take_id}
        fmt={(v) => `${v > 0 ? "+" : ""}${Math.round(v)} ms`} onChange={(v) => onChange({ offset_ms: v })} accent="accent-fuchsia-300" />
    </ChannelStrip>
  );
}
